// extracted by mini-css-extract-plugin
module.exports = {"hidden":"form-submit_hidden__S_022"};